module.exports = __webpack_public_path__ + "img/icon-lock.e56e7697.svg";